import { Box, Grid, Paper, Skeleton } from '@mui/material'
import React from 'react'

export default function PoolHoldingsSkeleton(): React.ReactElement {
  return (
    <Paper sx={{ p: 2 }}>
      <Box sx={{ mb: 2 }}>
        <Skeleton variant="text" width={200} height={40} />
      </Box>
      <Grid container spacing={8} sx={{ p: 3, mt: -3, ml: 0 }}>
        {[...Array(4)].map((_, i) => (
          <Grid item xs={12} sm={6} key={i}>
            <Skeleton variant="rectangular" height={100} />
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 2 }}>
        <Skeleton variant="text" width={150} height={30} />
        <Skeleton variant="rectangular" height={200} sx={{ mt: 1 }} />
      </Box>
    </Paper>
  )
}
